let language = {
    USER_REGIST_OR_TEXT: "或",
    USER_REGIST_SIGNUP_WITH_EMAIL: "使用您的电子邮箱注册",
    USER_REGIST_FORM_NICKNAME_LABEL: "昵称",
    USER_REGIST_FORM_NICKNAME_PLACEHOLDER: "请输入您的昵称",
    USER_REGIST_FORM_EMAIL_LABEL: "电子邮箱",
    USER_REGIST_FORM_EMAIL_PLACEHOLDER: "请输入有效的电子邮箱地址",
    USER_REGIST_FORM_EMAIL_ERROR_TIP1: "请输入正确的电子邮箱地址",
    USER_REGIST_FORM_PASSWORD_LABEL: "密码",
    USER_REGIST_FORM_PASSWORD_PLACEHOLDER: "请输入密码",
    USER_REGIST_FORM_PASSWORD_ERROR_TIP1: "请输入8至20个字符，包括大写、小写、数字和符号",
    USER_REGIST_FORM_REPEAT_PASSWORD_LABEL: "确认密码",
    USER_REGIST_FORM_REPEAT_PASSWORD_PLACEHOLDER: "请检查密码",
    USER_REGIST_FORM_SUBMIT_BTN: "注册",
    
    USER_REGIST_CONNECTION_ERROR_ALERT_TITLE: "连接错误",
};

export { language }